// extracted by mini-css-extract-plugin
export default {"search":"UserSearch_search__MDgj2"};